import { CategoryBox } from "@foodpilot/foods";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProductReference } from "src/api/sure-api/productReference/useGetOneProductReference";

type InfoProps = {
    title?: string | null;
    clientId?: string | null;
    productLine?: string | null;
    productReference?: ProductReference | null;
    brandName?: string | null;
    netWeight?: number | null;
    organic?: boolean;
    tags: string[];
};
export const ProductInformationSummary = (props: InfoProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { title, clientId, productReference, brandName, netWeight, organic, tags, productLine } = props;
    const noValue = "-";
    return (
        <Box
            component="table"
            sx={{
                display: "table",
                width: "100%",
                "&>tbody>tr>td": {
                    width: "430px",
                    borderBottom: `1px solid ${theme.custom.grey[500]}`,
                    padding: "20px 0px",
                },
            }}
        >
            <tbody>
                <tr>
                    <td>
                        <Typography variant="h4">{t("product.identity.name", "Product name")}</Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">{title ?? noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">
                            {t("product.identity.unique_identifier", "Unique identifier")}
                        </Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">{clientId ?? noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">
                            {t("product.reference_product_linked", "Reference product linked")}
                        </Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">{productReference?.name ?? noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">{t("product.identity.brand", "Brand")}</Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">{brandName ?? noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">
                            {t("product.v2.identity.organic_product", "Organic product")}
                        </Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">
                            {organic ? t("common.yes", "Yes") : t("common.no", "No")}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">{t("product.identity.netweight", "Net weight")}</Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">
                            {netWeight ?? noValue} {t("weight.grams", "grams")}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">{t("product.identity.product_line", "Product line")}</Typography>
                    </td>
                    <td>
                        <Typography variant="big-medium">{productLine ?? noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="h4">{t("common.categories", "Categories")}</Typography>
                    </td>
                    <td>
                        {tags.length === 0 ?
                            <Typography variant="big-medium">{noValue}</Typography>
                        :   <Box sx={{ display: "flex", gap: "10px" }}>
                                {tags.map((tag) => {
                                    return <CategoryBox key={`${tag}-summary-tag`} text={tag} />;
                                })}
                            </Box>
                        }
                    </td>
                </tr>
            </tbody>
        </Box>
    );
};
